import { useState } from 'react';
import { api } from '../lib/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState<{ devLink?: string } | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setErr(null);
    try {
      const res = await api.requestMagicLink(email);
      setDone({ devLink: res.dev_link });
    } catch (e: any) {
      setErr(e?.message || 'Request failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <h1 className="text-2xl font-semibold">Sign in</h1>
      <p className="text-mono-white/60 mt-2 text-sm">Enter your email — we'll send a magic link.</p>

      {!done ? (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-xs text-mono-white/60 uppercase tracking-widest">Email</span>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-ink-900 border border-ink-800 rounded-md px-3 py-2 text-mono-white focus:border-brand-600 focus:outline-none"
              placeholder="you@example.com"
            />
          </label>
          {err && <p className="text-alarm-red text-sm">{err}</p>}
          <button type="submit" disabled={submitting} className="btn-primary w-full">
            {submitting ? 'Sending…' : 'Send magic link'}
          </button>
        </form>
      ) : (
        <div className="mt-6 panel p-4">
          <p className="text-sm">Check your email for the sign-in link.</p>
          {done.devLink && (
            <p className="text-xs text-mono-white/50 mt-3">
              Dev mode: <a href={done.devLink} className="text-brand-600 underline break-all">{done.devLink}</a>
            </p>
          )}
        </div>
      )}
    </div>
  );
}
